import TopicPage from '../components/TopicPage';

const sections = [
  {
    title: 'Core Concepts',
    icon: '🧱',
    cards: [
      {
        icon: '📦',
        title: 'Pods',
        level: 'beginner',
        description: 'The smallest deployable unit in Kubernetes. A Pod wraps one or more containers sharing network and storage.',
        topics: ['Container spec', 'Init containers', 'Sidecar pattern', 'Pod lifecycle'],
      },
      {
        icon: '🔄',
        title: 'Deployments',
        level: 'beginner',
        description: 'Declarative updates for Pods. Manage rollouts, rollbacks, and scaling with ReplicaSets underneath.',
        topics: ['Rolling update', 'Rollback', 'ReplicaSet', 'Strategy'],
      },
      {
        icon: '🌐',
        title: 'Services',
        level: 'beginner',
        description: 'Stable network endpoint for a set of Pods. Types: ClusterIP, NodePort, LoadBalancer, ExternalName.',
        topics: ['ClusterIP', 'NodePort', 'LoadBalancer', 'DNS resolution'],
      },
      {
        icon: '⚙️',
        title: 'ConfigMaps & Secrets',
        level: 'beginner',
        description: 'Decouple configuration from container images. Secrets store sensitive data with base64 encoding.',
        topics: ['env vars', 'Volume mounts', 'Secret types', 'External secrets'],
      },
    ],
  },
  {
    title: 'Workloads & Scheduling',
    icon: '🗓️',
    cards: [
      {
        icon: '📋',
        title: 'StatefulSets',
        level: 'intermediate',
        description: 'Manage stateful applications with stable network IDs, ordered deployment and persistent storage.',
        topics: ['Stable identity', 'PVC templates', 'Headless service', 'Ordered updates'],
      },
      {
        icon: '🔧',
        title: 'DaemonSets',
        level: 'intermediate',
        description: 'Ensure a copy of a Pod runs on all (or selected) nodes. Common for logging, monitoring agents.',
        topics: ['Node selectors', 'Tolerations', 'Update strategy', 'Use cases'],
      },
      {
        icon: '⏱️',
        title: 'Jobs & CronJobs',
        level: 'intermediate',
        description: 'Run batch tasks to completion. CronJobs schedule Jobs on a cron schedule.',
        topics: ['Completions', 'Parallelism', 'Backoff limit', 'Cron syntax'],
      },
      {
        icon: '🎯',
        title: 'Resource Management',
        level: 'intermediate',
        description: 'Control CPU/memory with requests and limits. LimitRanges and ResourceQuotas enforce namespace policies.',
        topics: ['Requests/Limits', 'QoS classes', 'LimitRange', 'ResourceQuota'],
      },
    ],
  },
  {
    title: 'Networking & Storage',
    icon: '🔗',
    cards: [
      {
        icon: '🚪',
        title: 'Ingress',
        level: 'intermediate',
        description: 'HTTP/HTTPS routing to services. Ingress controllers (NGINX, Traefik) implement the rules.',
        topics: ['Path-based routing', 'TLS termination', 'Annotations', 'IngressClass'],
      },
      {
        icon: '💾',
        title: 'Persistent Volumes',
        level: 'intermediate',
        description: 'Abstract storage provisioning with PV, PVC and StorageClasses for dynamic provisioning.',
        topics: ['Access modes', 'Reclaim policy', 'StorageClass', 'Dynamic provisioning'],
      },
      {
        icon: '🛡️',
        title: 'Network Policies',
        level: 'advanced',
        description: 'Firewall rules for Pods. Control ingress/egress traffic at the namespace and pod level.',
        topics: ['Pod selector', 'Namespace selector', 'Port rules', 'Default deny'],
      },
    ],
  },
  {
    title: 'Security & Operations',
    icon: '🔐',
    cards: [
      {
        icon: '👤',
        title: 'RBAC',
        level: 'intermediate',
        description: 'Role-Based Access Control. Roles, ClusterRoles, RoleBindings restrict who can do what.',
        topics: ['Roles', 'ClusterRole', 'ServiceAccount', 'RoleBinding'],
      },
      {
        icon: '📊',
        title: 'Monitoring & Logging',
        level: 'intermediate',
        description: 'Prometheus + Grafana for metrics. EFK/ELK stack for centralized logging.',
        topics: ['Prometheus', 'Grafana', 'Loki', 'kubectl logs'],
      },
      {
        icon: '⎈',
        title: 'Helm',
        level: 'intermediate',
        description: 'Kubernetes package manager. Charts bundle manifests with templating for parameterized deployments.',
        topics: ['Charts', 'Values', 'Templates', 'Releases'],
      },
      {
        icon: '🔀',
        title: 'HPA & VPA',
        level: 'advanced',
        description: 'Horizontal Pod Autoscaler scales replicas based on CPU/memory. VPA adjusts resource requests.',
        topics: ['CPU scaling', 'Custom metrics', 'Scale-down policy', 'Stability window'],
      },
    ],
  },
];

function Kubernetes() {
  return (
    <TopicPage
      title="Kubernetes"
      subtitle="Container orchestration at scale — from Pods to production-grade cluster management."
      icon="⚙️"
      color="#326ce5"
      sections={sections}
    />
  );
}

export default Kubernetes;
